import { Component, Input, OnInit } from '@angular/core';
import { EmitterService } from '../../../../../core/utility/services/emitter.service';

@Component({
	selector: 'app-breadcrumb-anchor',
	styleUrls: ['./breadcrumb-anchor.component.css'],
	templateUrl: './breadcrumb-anchor.component.html'
})
export class BreadcrumbAnchorComponent implements OnInit {
	@Input() label: string;
	@Input() event: string;
	constructor() {}

	ngOnInit(): void {}

	clicked(): void {
		EmitterService.get(this.event).emit(this.event);
	}
}
